import { useRegistryEpoch } from "./use-registry-epoch.js";
import { flattenTranslations, getI18nTranslations } from "@videojs/core/i18n";
import { useMemo } from "react";
//#region src/i18n/use-merged-translations.ts
function useMergedTranslations(resolvedLocale, lazyLayer, translationsProp) {
	const registryEpoch = useRegistryEpoch();
	return useMemo(() => {
		const registryLayer = getI18nTranslations(resolvedLocale);
		return {
			...lazyLayer,
			...registryLayer,
			...flattenTranslations(translationsProp ?? {})
		};
	}, [
		resolvedLocale,
		lazyLayer,
		translationsProp,
		registryEpoch
	]);
}
//#endregion
export { useMergedTranslations };

//# sourceMappingURL=use-merged-translations.js.map